import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
import { styled } from '@creditas-ui/system';

interface AnimationBaseProps {
  children: React.ReactNode;
}

type AnimationProps = AnimationBaseProps & HTMLMotionProps<'div'>;

const AnimationElement = styled(motion.div)`
  height: 100%;
`;

const Animation = ({ children, ...props }: AnimationProps): JSX.Element => (
  <AnimationElement {...props}>{children}</AnimationElement>
);

export { Animation };
